export const getCaptchaToken = async (): Promise<string> => {
  if (typeof window?.turnstile?.reset !== 'function') {
    await new Promise(resolve => {
      const checkIsLoaded = () => {
        setTimeout(() => {
          if (typeof window?.turnstile?.reset === 'function') {
            resolve('')
          } else {
            checkIsLoaded()
          }
        }, 200)
      }
      checkIsLoaded()
    })
    return getCaptchaToken()
  }
  if (!window.turnstileId) {
    await new Promise(resolve => {
      const checkIsLoaded = () => {
        setTimeout(() => {
          if (window.turnstileId) {
            resolve('')
          } else {
            checkIsLoaded()
          }
        }, 200)
      }
      checkIsLoaded()
    })
    return getCaptchaToken()
  }
  window.turnstile.reset()
  return new Promise(resolve => {
    const checkGetResponse = () => {
      setTimeout(() => {
        const res = window.turnstile.getResponse()
        if (res) {
          resolve(res)
        } else {
          checkGetResponse()
        }
      }, 200)
    }
    checkGetResponse()
  })
}
